import React, { useState, useEffect } from "react"
import Button from "@/components/core/Button/Button"
import { useDispatch, useSelector } from "react-redux"
import { setShowShippingDetails } from "@/store/features/cartSlice"
import { checkCartStock } from "@/utils/helper"
import {
  getEventInfo,
  refreshCart,
} from "@/components/checkout/checkoutHelperFunction"
import ShippingInfo from "../cart/OrderSummary/ShippingInfo"
import OrderSummary from "@/components/cart/OrderSummary/OrderSummary"
import useWindowResize from "@/hooks/useWindowResize"
import { checkoutState } from "@/store/features/checkoutSlice"
import Modal from "@/components/core/Modal/Modal"
import { checkInactivePromos } from "./checkoutHelper"
import { addPlaceOrderDataLayer } from "@/components/checkout/v1/checkoutAnalytics"

const OrderReview = props => {
  const {
    i18n,
    legalLinks = {},
    status,
    statusCode = {},
    shippingDone,
    shippingItems,
    setStepLoading,
    cart,
    summaryProps = {},
    shippingProps = {},
    orderSummary = false,
  } = props

  const [width] = useWindowResize()
  // const [taxDown, setTaxDown] = useState(false)
  const dispatch = useDispatch()
  const { isPaymentInfo = false, checkoutStep } = useSelector(checkoutState)

  useEffect(() => {
    if (status === statusCode?.EDIT) {
      dispatch(
        setShowShippingDetails({ Parcel: true, LTL: true, Services: true })
      )
    }
  }, [])

  const handleSubmit = async () => {
    setStepLoading && setStepLoading(true)
    const res = await refreshCart
    if (res) {
      if (checkCartStock(cart)) {
        checkInactivePromos(setStepLoading, addPlaceOrderDataLayer)
      }
    } else {
      setStepLoading && setStepLoading(false)
      addPlaceOrderDataLayer()
    }
  }

  // const checkTaxFlag = () => {
  //   if (cart?.custom?.fields?.taxCalculationFlag) {
  //     handleSubmit()
  //   } else {
  //     setTaxDown(true)
  //     addPlaceOrderDataLayer()
  //   }
  // }
  // const onTaxModalClose = () => {
  //   setTaxDown(false)
  //   handleSubmit()
  // }

  return (
    <React.Fragment>
      {/* <div className="taxware-down">
        <Modal
          showModal={taxDown}
          onModalClose={onTaxModalClose}
          labelledBy="taxware-down-title"
        >
          <div id="taxware-down-title" className="taxware-down__title">
            {i18n.taxDownTitle}
          </div>
          <div className="taxware-down__desc">{i18n.taxDownDesc}</div>
          <Button
            customClass="taxware-down__cta"
            role="button"
            flexible
            label={i18n.continue}
            onClick={onTaxModalClose}
          />
        </Modal>
      </div> */}
      {status === statusCode.EDIT && (
        <div className="review-order">
          {!orderSummary ? (
            <div className="review-order__order-summary">
              <OrderSummary checkoutMode={true} i18n={i18n} {...summaryProps} />
              {width < 992 && shippingDone && shippingItems.length > 0 && (
                <ShippingInfo
                  i18n={i18n}
                  cartItems={summaryProps?.cartItems}
                  shippingItems={shippingItems}
                  currencySign={summaryProps?.currencySign}
                  {...shippingProps}
                />
              )}
            </div>
          ) : null}
        </div>
      )}
    </React.Fragment>
  )
}

export default OrderReview
